export enum TemplateType {
    /** 0 */
    INVOICE = 'INVOICE',
    /** 1 */
    SUPPLIER = 'SUPPLIER',
    /** 2 */
    REMITTANCE = 'REMITTANCE',
    /** 3 */
    ROUTING_INSTRUCTIONS = 'ROUTING_INSTRUCTIONS'
}
